import React, { useState } from 'react';
import Menu from './menu';
import Sidebar from './sidebar';
import Footer from './footer';


const Home = () => {
  // State to manage which accordion item is open
  const [activeAccordion, setActiveAccordion] = useState(null);
  
  // Function to handle accordion item click
  const handleAccordionClick = (index) => {
    if (activeAccordion === index) {
      // If the clicked accordion is already active, close it
      setActiveAccordion(null);
    } else {
      // Otherwise, set the clicked accordion as active
      setActiveAccordion(index);
    }
  };
  
  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-sm-12 col-lg-3 col-xl-3 col-md-3">
          <Sidebar />
        </div>
        <div className="col-sm-12 col-lg-9 col-xl-9 col-md-9">
          <Menu />

          <div className="bostami-page-content-wrap">
            <div className="section-wrapper pl-60 pr-60 pt-60">
              <div className="bostami-page-title-wrap mb-15">
                <div className="three">
                  <h1 className="">About</h1>
                </div>
                <div className="card shadow-lg p-5 mt-5 mb-5" style={{ border: 'none', borderLeft: '6px solid #1b74e4', borderRadius: '10px' }}>
                  <p>With a career spanning over <b>15 years,</b> I have cultivated a comprehensive and dynamic skill set that encompasses <b>.NET Full-Stack, MERN Stack, MSBI, Azure Application Development, Azure Data Engineering, SharePoint, Power BI, MongoDB, and Azure DevOps.</b> My extensive experience in these technologies has equipped me with the expertise to tackle complex challenges and deliver high-quality solutions. At Microsoft, I have had the privilege of leading the development and management of financial tools, ensuring they are not only scalable and stable but also efficient and user-centric.</p>
                </div>

                <div className="card shadow-lg p-5 mt-5 mb-5" style={{ border: 'none', borderRight: '6px solid #1b74e4', borderRadius: '10px' }}>
                  <p><b>My passion lies in innovating scalable and reliable solutions for tomorrow, driving efficiency and fostering innovation through interactive applications.</b></p>
                </div>
                <div className="card shadow-lg p-5 mt-5 mb-5" style={{ border: 'none', borderLeft: '6px solid #1b74e4', borderRadius: '10px' }}>
                  <p>In my role, I am dedicated to ensuring that every project I undertake is a testament to quality and reliability. Whether it’s architecting a new system, optimizing existing applications, or leading a team of developers, I bring a meticulous and innovative approach to my work. <b>My goal is to continue pushing the boundaries of what's possible in software development, leveraging the latest technologies to create innovative solutions that drive business success.</b> Beyond my professional achievements, I actively explore the latest tech trends and engage with the developer community to share knowledge and learn from others. This continuous learning mindset helps me stay at the forefront of the industry and bring fresh, cutting-edge ideas to my projects.</p>
                </div>
                <div className="card shadow-lg p-5 mt-5 mb-5" style={{ border: 'none', borderRight: '6px solid #1b74e4', borderRadius: '10px' }}>
                  <p>When I am not immersed in the world of coding and technology, I enjoy participating in tech conferences, contributing to open-source projects, and mentoring aspiring developers. <b>I believe in the power of collaboration and the importance of giving back to the community that has helped me grow. </b>My personal and professional journey is driven by a desire to innovate, create, and inspire. As I look to the future, I am excited about the possibilities that new technologies present and am committed to leveraging them to build solutions that make a meaningful impact.</p>
                </div>
              
              </div>
            </div>

            <div className="section-wrapper pl-60 pr-60">
              <div className="bostami-section-title-wrap mt-30 mb-20">
                {/*<div className="three">
                  <h1 className="">What I do!</h1>
                </div>*/}
                <div className="accordion accordion-flush mt-5" id="accordionFlushExample">
                  <div className="accordion-item ">
                    <h2 className="accordion-header shadow-lg" id="flush-headingOne">
                      <button
                        className={`accordion-button ${activeAccordion === 0 ? '' : 'collapsed'}`}
                        type="button"
                        onClick={() => handleAccordionClick(0)}
                      >
                     <h2>What I do!</h2>
                      </button>
                    </h2>
                    <div
                      id="flush-collapseOne"
                      className={`accordion-collapse collapse ${activeAccordion === 0 ? 'show' : ''}`}
                      aria-labelledby="flush-headingOne"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body">
                      <div className="bostami-what-do-wrap mb-30">
                <div className="row">
                  <div className="bostami-what-do-item bg-prink">
                    <div className="icon">
                      <i className="fa fa-laptop"></i>
                    </div>
                    <div className="text">
                      <h4 className="title">Full-Stack Development and Business Intelligence</h4>
                      <p>I specialize in building comprehensive applications using both .NET and MERN stack frameworks. My expertise in C#, ASP.NET, MVC, MongoDB, Express.js, React, and Node.js allows me to create robust, scalable, and high-performing web applications that meet complex business requirements. Additionally, I leverage Microsoft Business Intelligence tools (SQL Server, SSIS, SSAS, and SSRS) to transform raw data into meaningful insights, supporting data-driven decision-making for businesses.</p>
                    </div>
                  </div>
                  <div className="bostami-what-do-item bg-catkrill">
                    <div className="icon">
                      <i className="fa fa-laptop"></i>
                    </div>
                    <div className="text">
                      <h4 className="title">Cloud Solutions and Data Management</h4>
                      <p>As an experienced Azure developer, I design and deploy cloud-based solutions that are scalable, secure, and efficient, utilizing services like Azure Functions, Logic Apps, and Azure DevOps. I also have extensive experience in developing and customizing SharePoint solutions, ensuring environments are optimized for collaboration and productivity. Furthermore, I harness the power of Power BI to create interactive and insightful dashboards, and I utilize MongoDB for developing high-performance NoSQL database applications. My skills in implementing CI/CD pipelines with Azure DevOps streamline development workflows and improve productivity.</p>
                    </div>
                  </div>
                  <div className="bostami-what-do-item bg-catkrill">
                    <div className="icon">
                      <i className="fa fa-file-code-o"></i>
                    </div>
                    <div className="text">
                      <h4 className="title">Technology Mentoring, and Innovation</h4>
                      <p>Beyond development, I mentor aspiring developers, sharing my knowledge and experience to help them grow in their careers. Committed to staying at the forefront of technology, I continuously learn and explore new trends, bringing innovative solutions to projects to ensure they are future-proof and aligned with industry standards.</p>
                    </div>
                  </div>
                  <div className="bostami-what-do-item bg-prink bg-blue">
                    <div className="icon">
                      <i className="fa fa-folder-o"></i>
                    </div>
                    <div className="text">
                      <h4 className="title">Cross-Functional Team Leadership and Custom Solutions</h4>
                      <p>I lead cross-functional teams, fostering effective communication and teamwork to achieve project goals. I design and develop custom applications that fit specific business needs and specialize in seamless data integration and migration, ensuring data integrity and operational efficiency.</p>
                      <p>I prioritize strong client relationships through effective communication and reliable service delivery, focusing on long-term partnerships. Additionally, I optimize application performance to enhance speed, reliability, and user experience, ensuring efficient and responsive software solutions.</p>
                    </div>
                  </div>
                </div>
              </div>
                      </div>
                    </div>
                  </div>
                 
                </div>
              </div>

              

            </div>
            <Footer />
          </div>

        </div>
      </div>
     
    </div>
  );
}

export default Home;
